import Header from './components/Header';
import Hero from './components/Hero';
import MarqueeSection from './components/MarqueeSection';
import ForWhoSection from './components/ForWhoSection';
import ProblemsSection from './components/ProblemsSection';
import SolutionSection from './components/SolutionSection';
import WhatIncludedSection from './components/WhatIncludedSection';
import ResultsSection from './components/ResultsSection';
import CasesSection from './components/CasesSection';
import CooperationStages from './components/CooperationStages';
import CalculatorSection from './components/CalculatorSection';
import WhyUsSection from './components/WhyUsSection';
import ProcessSection from './components/ProcessSection';
// import CTASection from './components/CTASection';
// import TariffsSection from './components/TariffsSection';
import ReferralSection from './components/ReferralSection';
import TextMarquee from './components/TextMarquee';
import FAQSection from './components/FAQSection';
import ContactFormSection from './components/ContactFormSection';
import LettersSlider from './components/LettersSlider';
import Footer from './components/Footer';
import Modal from './components/Modal';
import TelegramPromoModal from './components/TelegramPromoModal';
import { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenModal = () => setIsModalOpen(true);
    window.addEventListener('openModal', handleOpenModal);
    return () => window.removeEventListener('openModal', handleOpenModal);
  }, []);

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      <Header />
      <Hero />
      <ForWhoSection />
      <MarqueeSection />
      <LettersSlider />
      <ProblemsSection />
      <SolutionSection />
      <WhatIncludedSection />
      <ResultsSection />
      <CasesSection />
      <CooperationStages />
      <CalculatorSection />
      <WhyUsSection />
      <ProcessSection />
      {/* <TariffsSection /> */}
      <ReferralSection />
      <FAQSection />
      <TextMarquee />
      <ContactFormSection />
      {/* <CTASection /> */}
      <Footer />
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <TelegramPromoModal />
    </div>
  );
}

// Экспортируем функцию для открытия модалки
export const openModal = () => {
  window.dispatchEvent(new Event('openModal'));
};

export default App;
